import { render, staticRenderFns } from "./PayrollUser.vue?vue&type=template&id=c5150362&scoped=true"
import script from "./PayrollUser.vue?vue&type=script&lang=js"
export * from "./PayrollUser.vue?vue&type=script&lang=js"
import style0 from "./PayrollUser.vue?vue&type=style&index=0&id=c5150362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5150362",
  null
  
)

export default component.exports